"use strict";
var HASH_UNDEFINED = '__lodash_hash_undefined__';
function setCacheAdd(value) {
    this.__data__.set(value, HASH_UNDEFINED);
    return this;
}
module.exports = setCacheAdd;
//# sourceMappingURL=_setCacheAdd.js.map